import axios from 'axios';

const url = process.env.REACT_APP_API_URL;
const port = process.env.REACT_APP_API_PORT;
const basePath = process.env.REACT_APP_API_BASEPATH;

const api = axios.create({ baseURL: url + ":" + port + basePath });
export const uploadPath = url + ":" +port;

export default api;